import { render, staticRenderFns } from "./RunBookLink.vue?vue&type=template&id=1f5861ec&"
import script from "./RunBookLink.vue?vue&type=script&lang=js&"
export * from "./RunBookLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports